// Cookie consent manager (AEPD compliant).
// Meta Pixel and analytics load ONLY after the matching consent is granted.

const CONSENT_KEY = "dep_cookie_consent_v1";
const TWELVE_MONTHS_MS = 365 * 24 * 60 * 60 * 1000;

const META_PIXEL_ID = "1129972809096366";
const POSTHOG_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";
const POSTHOG_HOST = "https://us.i.posthog.com";

/* Read stored consent; returns null if absent or older than 12 months. */
export function getConsent() {
    if (typeof window === "undefined") return null;
    try {
        const raw = localStorage.getItem(CONSENT_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (!data || typeof data.ts !== "number") return null;
        if (Date.now() - data.ts > TWELVE_MONTHS_MS) return null;
        return { analytics: !!data.analytics, ads: !!data.ads };
    } catch (e) {
        return null;
    }
}

/* Persist consent choice with a timestamp (12-month validity). */
export function saveConsent({ analytics, ads }) {
    try {
        localStorage.setItem(
            CONSENT_KEY,
            JSON.stringify({ analytics: !!analytics, ads: !!ads, ts: Date.now() }),
        );
    } catch (e) {
        // ignore storage failures
    }
}

/* Load Meta Pixel (idempotent). Only call after ADS consent. */
export function loadMetaPixel() {
    if (typeof window === "undefined" || window.__depPixelLoaded) return;
    window.__depPixelLoaded = true;
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
}

/* Load PostHog analytics (idempotent). Only call after ANALYTICS consent. */
export function loadPostHog() {
    if (typeof window === "undefined" || window.__depPosthogLoaded) return;
    window.__depPosthogLoaded = true;
    /* eslint-disable */
    !(function (t, e) {
        var o, n, p, r;
        e.__SV ||
            ((window.posthog = e),
            (e._i = []),
            (e.init = function (i, s, a) {
                function g(t, e) {
                    var o = e.split(".");
                    2 == o.length && ((t = t[o[0]]), (e = o[1])),
                        (t[e] = function () {
                            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                        });
                }
                ((p = t.createElement("script")).type = "text/javascript"),
                    (p.crossOrigin = "anonymous"),
                    (p.async = !0),
                    (p.src =
                        s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") +
                        "/static/array.js"),
                    (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
                var u = e;
                for (
                    void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
                        u.people = u.people || [],
                        u.toString = function (t) {
                            var e = "posthog";
                            return "posthog" !== a && (e += "." + a), t || (e += " (stub)"), e;
                        },
                        u.people.toString = function () {
                            return u.toString(1) + ".people (stub)";
                        },
                        o = "init capture identify reset register register_once people set_config".split(
                            " ",
                        ),
                        n = 0;
                    n < o.length;
                    n++
                )
                    g(u, o[n]);
                e._i.push([i, s, a]);
            }),
            (e.__SV = 1));
    })(document, window.posthog || []);
    /* eslint-enable */
    window.posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        person_profiles: "identified_only",
        session_recording: { recordCrossOriginIframes: true, capturePerformance: false },
    });
}

/* Apply a consent object: load only the granted categories. */
export function applyConsent(consent) {
    if (!consent) return;
    if (consent.ads) loadMetaPixel();
    if (consent.analytics) loadPostHog();
}

export const openCookieSettings = () => {
    if (typeof window !== "undefined") {
        window.dispatchEvent(new Event("dep:open-cookie-settings"));
    }
};
